import { Loader, PageTitle } from '../../components';

import { Helmet } from 'react-helmet-async';
import TeamMembers from '../../components/Team/TeamMembers/TeamMembers';
import clientConfig from '../../client-config';
import logo from '../../assets/images/logo.webp';
import logoOg from '../../assets/images/logoog.jpg'
import useFetchStaff from '../../hooks/useFetchStaff';

const MeetTheTeam = () => {
  const wordPressSiteURL = clientConfig.siteUrl;

  const { staff, loading, error } = useFetchStaff(wordPressSiteURL);


  return (
    <div className="py-12 bg-white">
      {/* Meta */}
      <Helmet>
        <title>Kenworthy Chiropractic | Meet the Team</title>
        <meta property='og:description' content='Kenworthy Chiropractic – Get to know our fantastic and wonderful team of Chiropractors and Chiropractic Assistants' />
        <meta property="og:title" content={`Kenworthy Chiropractic | Meet the Team`} />
        <meta property="og:type" content="website" />"
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={logoOg} />
        <meta property="og:image:secure_url" content={logoOg} />
        <meta property="og:image:width" content="1920" />
        <meta property="og:image:height" content="1080" />
      </Helmet>

      <div className="max-w-5xl px-2 mx-auto">
        <PageTitle title="Meet The Team" />

        {/* Conditioning for the team loading in */}
        {error ? (
          <Loader logo={logo} textLineOne="The team are still working..." textLineTwo="Please try refreshing the page." />
        ) :
          loading ? (
            <Loader logo={logo} textLineOne="Chiropractors Assemble!" />
          ) : (
            <div className="grid mt-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 md:px-5">
              <TeamMembers team={staff} />
            </div>
          )
        }


      </div>
    </div>
  );
};

export default MeetTheTeam;
